/* global Raven, NODE_ENV */
// запрос на сервер и парсинг json
import { get as getCookie } from "es-cookie";
import showNotification from "scripts/dom_utils/notification";
/**
 * Main fetch wrapper util method
 *
 * @param {string} url  - url for fetch request
 * @param {Object} customOptions [={}]  - fetch like options object
 * @param {string} anticipatedDataFormat [="json"]  - options anticipated data format
 * @returns {Promise<Response | never>}
 *
 * @example
 *   const url = getRequestUrl(); // inner logic does't matter
 *   const options = getRequestOptions(); // inner logic does't matter
 *   doFetch(url, options)
 *     .catch((resp) => ... // some logic );
 */

export default function doFetch(url, customOptions = {}, anticipatedDataFormat = "json") {
  const optionsTemplate = {
    method: "GET",
    credentials: "same-origin",
    headers: {
      "X-REQUESTED-WITH": "XMLHttpRequest",
      "X-CSRFToken": getCookie("csrftoken")
    }
  };
  const customHeaders = customOptions ? customOptions.headers : {};
  const options = { ...optionsTemplate,
    ...customOptions,
    headers: { ...optionsTemplate.headers,
      ...customHeaders
    }
  };
  return new Promise((resolve, reject) => {
    fetch(url, options).then(async response => {
      if (response.status >= 401 && response.status < 600) {
        throw response;
      } // The HTTP 204 No Content


      if (response.status === 204) {
        resolve({});
        return;
      }

      const data = await response[anticipatedDataFormat]();
      resolve(data);
    }).catch(error => {
      reject({
        url,
        headers: { ...options.headers,
          "X-CSRFToken": "[REDACTED]"
        },
        networkError: error
      });
      showNotification({
        text: "Ошибка при загрузке данных с сервера. Попробуйте перезагрузить страницу",
        status: "error"
      });
    });
  });
}